import { createActions } from "../../helpers/utils/createActions";
import { STYLE } from "./actionTypes";

export const getListaStyle = createActions(STYLE.GET_LISTA_STYLE);
export const getStyle = createActions(STYLE.GET_STYLE);
export const saveStyle = createActions(STYLE.SAVE_STYLE);

export const getStyleHistory = createActions(STYLE.GET_STYLE_HISTORY);
export const getStyleHistoryList = createActions(STYLE.GET_STYLE_HISTORY_LIST);

export const changePageSizeStyle = (payload) => ({ type: STYLE.CHANGE_PAGE_SIZE_STYLE, payload });
export const loadEmptyStyle = () => ({ type: STYLE.LOAD_EMPTY_STYLE })
export const cleanMessageStyle = () => ({ type: STYLE.CLEAN_MESSAGE_STYLE })
export const disableLoadingStyle = () => ({ type: STYLE.DISABLE_LOADING_STYLE })